// extracted by mini-css-extract-plugin
module.exports = {"name":"Contact_name__3Grs_","number":"Contact_number__2nW6O","item":"Contact_item__12DVc","button":"Contact_button__1OsFW"};